import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ArrowForwardIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M15.8468 13L12 16.5611L13.367 18L18.8795 13H19V12.8907L20 11.9836L19 11.0599V11H18.9351L13.5223 6L12.1214 7.49814L15.887 11L4 11L4 13L15.8468 13Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
ArrowForwardIcon.displayName = 'ArrowForwardIcon'
export default ArrowForwardIcon
